<div class="dialog-wrapper" dir="rtl">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">
      {{ isEditMode ? "تعديل العميل" : "بيانات العميل" }}
    </h2>
    <button class="close-btn" (click)="onClose()">&#x2715;</button>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- ── Section title ── -->
    <div class="section-title-block">
      <h3 class="section-title">العملاء</h3>
      <p class="section-subtitle">Here you can manage customer details.</p>
    </div>

    <!-- ── Photo Upload Row ── -->
    <div class="photo-row">
      <!-- Preview circle -->
      <div class="photo-preview">
        <img
          *ngIf="photoPreview"
          [src]="photoPreview"
          alt="صورة العميل"
          class="preview-img"
        />
        <div *ngIf="!photoPreview" class="preview-placeholder">
          <span class="placeholder-icon">&#128100;</span>
        </div>
      </div>

      <!-- Upload controls -->
      <div class="photo-controls" *ngIf="isEditMode">
        <input
          #fileInput
          type="file"
          accept="image/*"
          (change)="onFileChange($event)"
          hidden
        />
        <div class="file-input-row">
          <span class="no-file-label">{{
            selectedFileName || "No file chosen"
          }}</span>
          <button class="btn btn-choose" (click)="fileInput.click()">
            Choose File
          </button>
        </div>
        <button class="btn btn-camera" (click)="openCamera()">
          تجهيز الكاميرا
        </button>
        <button class="btn btn-capture" (click)="capturePhoto()">
          إلتقط صوره
        </button>
      </div>
    </div>

    <!-- ── Row 1: الاسم الأول / الأوسط / الأخير ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">الاسم الأخير</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.lastName"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">الإسم الأوسط</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.middleName"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">الإسم الأول</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.firstName"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
          placeholder="عميل إختبار"
        />
      </div>
    </div>

    <!-- ── Row 2: رقم الهاتف / الأرضي / البريد ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">البريد الإلكتروني</label>
        <input
          type="email"
          class="form-input"
          [(ngModel)]="customer.email"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">الرقم الأرضى</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.landline"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">رقم الهاتف</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.phone"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
          placeholder="0111111119"
        />
      </div>
    </div>

    <!-- ── Row 3: عنوان / إضافي / المدينة ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">المدينة</label>
        <div class="select-wrapper" *ngIf="isEditMode; else cityView">
          <select class="form-select" [(ngModel)]="customer.city">
            <option value="Cairo">Cairo</option>
            <option value="Alexandria">Alexandria</option>
            <option value="Giza">Giza</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #cityView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.city"
            readonly
          />
        </ng-template>
      </div>
      <div class="form-group">
        <label class="form-label">عنوان إضافي</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.addressExtra"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">عنوان</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.address"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
    </div>

    <!-- ── Row 4: تاريخ الميلاد / الرقم القومى / رقم العضوية ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">رقم العضوية</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="customer.membershipNumber"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
          placeholder="1"
        />
      </div>
      <div class="form-group">
        <label class="form-label">الرقم القومى</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.nationalId"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">تاريخ الميلاد</label>
        <input
          type="date"
          class="form-input ltr-input"
          [(ngModel)]="customer.birthDate"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
    </div>

    <!-- ── Row 5: كود الدخول / البنك / الموقع ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">الموقع</label>
        <div class="select-wrapper" *ngIf="isEditMode; else locationView">
          <select class="form-select" [(ngModel)]="customer.location">
            <option value="TestBranch">TestBranch</option>
            <option value="Branch2">Branch 2</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #locationView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.location"
            readonly
          />
        </ng-template>
      </div>
      <div class="form-group">
        <label class="form-label">البنك</label>
        <div class="select-wrapper" *ngIf="isEditMode; else bankView">
          <select class="form-select" [(ngModel)]="customer.bank">
            <option value="Egypt">Egypt</option>
            <option value="CIB">CIB</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #bankView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.bank"
            readonly
          />
        </ng-template>
      </div>
      <div class="form-group">
        <label class="form-label">كود الدخول</label>
        <input
          type="text"
          class="form-input ltr-input"
          [(ngModel)]="customer.accessCode"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
          placeholder="1"
        />
      </div>
    </div>

    <!-- ── Row 6: مسؤول المبيعات / مدرب / الشركة ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">الشركة</label>
        <div class="select-wrapper" *ngIf="isEditMode; else companyView">
          <select class="form-select" [(ngModel)]="customer.company">
            <option value="None">None</option>
            <option value="Company1">Company 1</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #companyView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.company"
            readonly
          />
        </ng-template>
      </div>
      <div class="form-group">
        <label class="form-label">مدرب التدريبات الخاصة</label>
        <div class="select-wrapper" *ngIf="isEditMode; else trainerView">
          <select class="form-select" [(ngModel)]="customer.trainer">
            <option value="None">None</option>
            <option value="Trainer1">Trainer 1</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #trainerView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.trainer"
            readonly
          />
        </ng-template>
      </div>
      <div class="form-group">
        <label class="form-label">مسؤول المبيعات</label>
        <div class="select-wrapper" *ngIf="isEditMode; else salesView">
          <select class="form-select" [(ngModel)]="customer.salesManager">
            <option value="testusernewui">testusernewui</option>
            <option value="Admin">Admin</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #salesView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.salesManager"
            readonly
          />
        </ng-template>
      </div>
    </div>

    <!-- ── Row 7: النوع / إسم الطوارى / رقم هاتف الطوارى ── -->
    <div class="form-row three-col">
      <div class="form-group">
        <label class="form-label">رقم هاتف الطوارى</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.emergencyPhone"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">إسم الطوارى</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="customer.emergencyName"
          [readonly]="!isEditMode"
          [class.readonly]="!isEditMode"
        />
      </div>
      <div class="form-group">
        <label class="form-label">النوع</label>
        <div class="select-wrapper" *ngIf="isEditMode; else genderView">
          <select class="form-select" [(ngModel)]="customer.gender">
            <option value="ذكر">ذكر</option>
            <option value="أنثى">أنثى</option>
          </select>
          <span class="select-arrow">&#8249;</span>
        </div>
        <ng-template #genderView>
          <input
            type="text"
            class="form-input readonly"
            [value]="customer.gender"
            readonly
          />
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إغلاق</button>
    <button *ngIf="isEditMode" class="btn btn-submit" (click)="onSubmit()">
      تسجيل
    </button>
    <button *ngIf="!isEditMode" class="btn btn-edit" (click)="enableEdit()">
      تعديل
    </button>
  </div>
</div>
